import { useEffect, useState } from "react";
import { TabsContent } from "@/components/ui/tabs";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CalendarSkeleton from "@/components/skeleton/celender-skeletion";
import MonthYearSelector from "@/components/common/month-year-selector";

const dayLabels = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

function CalendarControls({ monthDate, setMonthDate }) {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(null);
  const { calender, getLoading } = useSelector(
    (state) => state.staffManage.timeSheet
  );

  const handleDateClick = (day) => {
    setSelectedDate(day.date);
  };

  const dayGrid = [];
  if (calender?.calendar_data) {
    const firstDayIndex = dayLabels.indexOf(calender.calendar_data[0].day);
    for (let i = 0; i < firstDayIndex; i++) dayGrid.push(null);
    dayGrid.push(...calender.calendar_data);
  }
  // if (getLoading) return <CalendarSkeleton />;

  return (
    <TabsContent value="calender">
      {getLoading ? (
        <CalendarSkeleton />
      ) : (
        <div className="p-4 text-white">
          <div className="flex gap-4 mb-6">
            <MonthYearSelector
              defaultValue={monthDate}
              onChange={(val) => setMonthDate(val)}
            />
          </div>

          <div className="border border-gray-600 rounded-lg overflow-hidden">
            <div className="grid grid-cols-7 text-center text-sm font-medium text-cwhite2 bg-cblack5">
              {dayLabels?.map((d) => (
                <div className="border py-3 border-gray-600" key={d}>
                  {d}
                </div>
              ))}
            </div>

            <div className="grid grid-cols-7 bg-cblack5">
              {dayGrid?.map((day, i) => {
                if (!day)
                  return (
                    <div
                      key={`empty-${i}`}
                      className="border border-gray-700 h-24"
                    ></div>
                  );

                const isSelected = selectedDate === day?.date;

                return (
                  <div key={i}>
                    <Link
                      to={`/backoffice/staff-management/time-sheet-report/${monthDate}-${String(
                        day.date
                      ).padStart(2, "0")}`}
                    >
                      <div
                        onClick={() => {
                          handleDateClick(day);
                        }}
                        className={`border rounded px-2 py-4 text-xs cursor-pointer flex flex-col gap-3 items-center justify-center
                        ${
                          isSelected
                            ? ""
                            : "border-gray-700 text-gray-200 hover:bg-cblack6"
                        }
                        ${
                          day?.is_today
                            ? "bg-cblack3 !border-cyellow text-cyellow font-semibold"
                            : ""
                        }
                      `}
                      >
                        <div className="text-2xl font-bold">{day?.date}</div>
                        <div className="mt-1">{day?.staff_count} Staff</div>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </TabsContent>
  );
}

export default CalendarControls;
